import { Pipe } from '@angular/core';
var TruncateCharactersPipe = (function () {
    function TruncateCharactersPipe() {
    }
    TruncateCharactersPipe.prototype.transform = function (value, limit, trail) {
        if (limit === void 0) { limit = 40; }
        if (trail === void 0) { trail = '…'; }
        if (!value) {
            value = '';
        }
        if (limit < 0) {
            limit *= -1;
            return value.length > limit ? trail + value.substring(value.length - limit, value.length) : value;
        }
        else {
            return value.length > limit ? value.substring(0, limit) + trail : value;
        }
    };
    TruncateCharactersPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'truncate'
                },] },
    ];
    /** @nocollapse */
    TruncateCharactersPipe.ctorParameters = function () { return []; };
    return TruncateCharactersPipe;
}());
export { TruncateCharactersPipe };
//# sourceMappingURL=truncate-characters.pipe.js.map


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/ng2-truncate/dist/truncate-characters.pipe.js
// module id = ../../../../ng2-truncate/dist/truncate-characters.pipe.js
// module chunks = 4